{
    "name": "@slashid/slashid",
    "private": false,
    "publishConfig": {
        "access": "public"
    },
    "version": "3.27.3",
    "description": "Client SDK for the /id platform",
    "homepage": "https://slashid.dev",
    "author": "SlashID",
    "license": "MIT",
    "main": "./dist/bundle/slashid.js",
    "module": "./dist/esmodule/slashid.esm.js",
    "esmodule": "./dist/esmodule/slashid.esm.js",
    "commonjs": "./dist/commonjs/slashid.cjs.js",
    "bundle": "./dist/bundle/slashid.js",
    "types": "./dist/types/slashid.d.ts",
    "exports": {
        ".": {
            "require": "./dist/commonjs/slashid.cjs.js",
            "import": "./dist/esmodule/slashid.esm.js",
            "default": "./dist/commonjs/slashid.cjs.js",
            "types": "./dist/types/slashid.d.ts"
        }
    },
    "targets": {
        "esmodule": {
            "source": "src/targets/package.ts",
            "context": "browser",
            "isLibrary": true,
            "outputFormat": "esmodule",
            "engines": {
                "browsers": [
                    "and_chr >= 73",
                    "chrome >= 73",
                    "and_ff >= 67",
                    "android >= 114",
                    "edge >= 79",
                    "samsung >= 11.2",
                    "safari >= 13",
                    "ios_saf >= 13.1",
                    "opera >= 60",
                    "firefox >= 67",
                    "unreleased and_chr versions",
                    "unreleased chrome versions",
                    "unreleased and_ff versions",
                    "unreleased android versions",
                    "unreleased edge versions",
                    "unreleased samsung versions",
                    "unreleased safari versions",
                    "unreleased ios_saf versions",
                    "unreleased opera versions",
                    "unreleased firefox versions"
                ]
            }
        },
        "commonjs": {
            "source": "src/targets/package.ts",
            "context": "node",
            "isLibrary": true,
            "outputFormat": "commonjs",
            "engines": {
                "node": ">= 12"
            }
        },
        "bundle": {
            "source": "src/targets/bundle.ts",
            "context": "browser",
            "outputFormat": "global",
            "engines": {
                "browsers": [
                    "> 0.5%",
                    "last 2 versions",
                    "not dead"
                ]
            }
        },
        "page": {
            "source": "static/sdk.html",
            "context": "browser",
            "engines": {
                "browsers": [
                    "and_chr >= 73",
                    "chrome >= 73",
                    "and_ff >= 67",
                    "android >= 114",
                    "edge >= 79",
                    "samsung >= 11.2",
                    "safari >= 13",
                    "ios_saf >= 13.1",
                    "opera >= 60",
                    "firefox >= 67",
                    "unreleased and_chr versions",
                    "unreleased chrome versions",
                    "unreleased and_ff versions",
                    "unreleased android versions",
                    "unreleased edge versions",
                    "unreleased samsung versions",
                    "unreleased safari versions",
                    "unreleased ios_saf versions",
                    "unreleased opera versions",
                    "unreleased firefox versions"
                ]
            }
        },
        "types": {
            "source": "src/targets/package.ts"
        }
    },
    "files": [
        "dist/*"
    ],
    "keywords": [
        "slashid",
        "SlashID",
        "auth",
        "openid",
        "authentication",
        "jwt",
        "browser"
    ],
    "scripts": {
        "clean": "rm -rf dist docs",
        "lint": "eslint ./src --ext .ts",
        "format": "prettier --config .prettierrc.json 'src/**/*.ts' --write",
        "test:ts": "tsc --project tsconfig.json --noEmit",
        "test:unit": "jest",
        "test:unit:watch": "jest --watch",
        "test:unit:ci": "jest --ci",
        "test:integration": "playwright test",
        "build": "rm -rf dist && parcel build --no-cache && cp compat/esmodule/package.json dist/esmodule",
        "docs": "rm -rf docs && typedoc",
        "dist": "npm run lint && npm run build",
        "all": "npm run dist && npm run docs",
        "serve:all": "parcel serve 'static/*.html' --port 8080 --no-cache",
        "serve:example": "parcel serve static/index.html --port 8080 --no-cache",
        "serve:jump": "parcel serve static/sdk.html --port 8080 --no-cache",
        "serve:docs": "parcel serve docs/index.html --port 8081 --no-cache",
        "push:docs": "aws s3 sync docs s3://slashiddoc/sdk/v$(node tools/version.js --major) && (aws cloudfront create-invalidation --distribution-id ETLBNGAAF97EN --paths \"/*\")",
        "changeset": "changeset",
        "prepublishOnly": "npm run all",
        "publish:ci": "npm run build && changeset publish"
    },
    "devDependencies": {
        "@parcel/core": "2.12.0",
        "@parcel/packager-ts": "2.12.0",
        "@parcel/resolver-default": "^2.12.0",
        "@parcel/transformer-babel": "2.12.0",
        "@parcel/transformer-js": "2.12.0",
        "@parcel/transformer-json": "2.12.0",
        "@parcel/transformer-react-refresh-wrap": "2.12.0",
        "@parcel/transformer-typescript-types": "2.12.0",
        "@playwright/test": "1.42.1",
        "@types/jest": "^28.1.7",
        "@types/node": "~15.0.2",
        "@types/qrcode": "^1.5.0",
        "@types/ua-parser-js": "^0.7.39",
        "@typescript-eslint/eslint-plugin": "^4.15.1",
        "@typescript-eslint/parser": "^4.15.1",
        "danger": "^11.2.6",
        "eslint": "^7.20.0",
        "eslint-config-prettier": "^8.5.0",
        "eslint-plugin-prettier": "^4.2.1",
        "isomorphic-fetch": "^3.0.0",
        "jest": "^28.1.3",
        "jest-environment-jsdom": "^28.1.3",
        "jest-fetch-mock": "^3.0.3",
        "parcel": "2.12.0",
        "prettier": "^2.7.1",
        "ts-jest": "^28.0.8",
        "typedoc": "^0.23.00",
        "typedoc-plugin-mdn-links": "^2.0.0",
        "typedoc-plugin-missing-exports": "^1.0.0",
        "typescript": "~4.7.0"
    },
    "dependencies": {
        "@changesets/cli": "^2.27.5",
        "@types/uuid": "8.3.4",
        "compare-versions": "^6.1.0",
        "docdash": "^1.2.0",
        "jwt-decode": "^3.1.2",
        "qrcode": "^1.5.1",
        "querystring-es3": "^0.2.1",
        "regenerator-runtime": "^0.13.9",
        "ua-parser-js": "^1.0.37",
        "url": "^0.11.0",
        "uuid": "8.3.2"
    }
}
